import { SVAccountLabel, SVLabeledText } from '@/components/core';
import SVLink from '@/components/core/SVLink';
import { TransactionRequestSelectionItem } from '@/types/transactionRequests';
import { Divider, Grid, Typography } from '@mui/material';

type CreateTransactionConfirmProps = {
  fromAccount?: TransactionRequestSelectionItem;
  toAccount?: TransactionRequestSelectionItem;
  amount: string;
  note?: string;
  instructions?: string;
  purpose?: string;
  isWire?: boolean;
};

export default function CreateTransactionConfirm({
  fromAccount,
  toAccount,
  amount,
  note,
  instructions,
  purpose,
  isWire,
}: CreateTransactionConfirmProps) {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <SVAccountLabel account={fromAccount} label="From" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <SVAccountLabel account={toAccount} label="To" />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <SVLabeledText label="Amount" text={`$${amount}`} />
      </Grid>
      {note && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <SVLabeledText label="Note" text={note} />
        </Grid>
      )}
      {instructions && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <SVLabeledText label="Instructions" text={instructions} />
        </Grid>
      )}
      {purpose && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <SVLabeledText label="Purpose" text={purpose} />
        </Grid>
      )}
      <Divider sx={{ width: '100%' }} />
      <Grid size={{ xs: 12 }}>
        {isWire && (
          <Typography>
            Domestic wires are typically processed the same business day if
            submitted before the wire cutoff time.{' '}
            <SVLink
              to="https://www.grasshopper.bank/faqs/transaction-cutoff-times/"
              target="_blank">
              View cutoff times
            </SVLink>
            .
          </Typography>
        )}
        <Typography variant="caption">
          Note: All owners on the account will receive a transaction requests
        </Typography>
      </Grid>
    </Grid>
  );
}
